import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-gowish gowish-btn",
  id: "gowishWhiteButton",
  type: "button",
  "data-region": "denmark"
}

import { computed, ref } from "vue";
import CloudIcon from "@web/assets/icon/cloud.svg";

import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'GoWish',
  setup(__props) {

const store = useStore();

const language = computed(() => store.state.app.language);
const translations = computed(() => store.state.translations.siteTranslations);

return (_ctx: any,_cache: any) => {
  return (language.value == 'DA')
    ? (_openBlock(), _createElementBlock("button", _hoisted_1, [
        _createVNode(_unref(CloudIcon)),
        _createTextVNode(" " + _toDisplayString(translations.value["addToGoWish"]), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})